<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'dealerproducts.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="theGrid" name="dealerProductsGrid" :preload="preload" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'UsersGrid',
  components: {
    Grid
  },
  data() {
    return {
      gridFilters: [{
        field:'dealer_id',
        modal:'dealers-modal',
        foreign: 'id',
        placeholder: 'Distribuidor'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dealer_id': {
          type: 'number'
        }
      },
      url: 'dealer-products',
      preload: [{
        api: 'dealers/lst',
        field: 'dealer_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        values:[],
        width: '180px'
      },
      {
        field: 'product_id',
        title: 'Id Produto',
        width: '220px'
      },
      {
        field: 'product.data.name',
        title: 'Produto',
        width: '220px'
      },
      {
        field: 'product.data.sku',
        title: 'SKU',
        width: '220px'
      },
      {
        field: 'code',
        title: 'Código',
        width: '120px'
      },
      {
        field: 'quantity',
        title: 'Quantidade',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'dealerproducts.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('dealerproducts.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
